// IE 2026 10 04 / ODOO-5800 (fe-78) (Igor 04.10: «в поле метрики — сигнал»; «заголовок метрики и её справочника везде назвать как "Сигнал"; то же и в плане причины»;
// поля-дубли уходят; Вид, Сигнал, Причина, Рішення, Базис — ссылочные поля): МОДЕЛЬ СИГНАЛОВ v2 НА ФРОНТЕ. Чистый модуль: без Vue, стора и DOM.
// Контракт бэка (STAGE_A.md, выключатель бэка not-signals.model_v2):
//   строка грида сигналов (_doc.metrics_stats): metric — id сигнала (сегмент METRIC), reason — id причины (REASON), signal_kind — id записи вида
//     ('SIGNAL-KIND_problem | kpi | info'), solution — id записи-решения (SOLUTION), amount_basis — id записи-базиса (AMOUNT-BASIS); запасные названия
//     metric_title / reason_title (пока сегменты не пересеяны). Полей-дублей problem / cause_short / metric-title / reason-title / kind / signal_kind_title нет;
//   запись словаря чипса: + signal_kind_id, solution, amount_basis; signal = 'm:<id сигнала>', названия — metric_title / reason_title (названия записей);
//   форма ячейки: story.signal_model = 2; элемент problems — signal_id, cause_id, signal_kind_id, solution_id, amount_basis_id; причины — cause_id, решения — solution_id.
// Прежний бэк (новых полей нет) — все функции возвращают «не v2» / пустое значение, потребители работают как в fe-77. Выключатель fe.signals.modelV2 (дефолт ВКЛ;
// false — поведение fe-77 и при новом бэке).
export const MODEL_V2_KEY = 'fe.signals.modelV2'
let _forced = null, _cached = true, _at = 0
// тесты / консоль: true | false — принудительно, null — по настройке
export function modelV2_force(v) { _forced = v === null || v === undefined ? null : !!v; _at = 0 }
// настройка fe.*: localStorage feSettings (override пользователя) → feSettings.db (настройка базы) → def
export function feFlag_read(key, def = true) {
    try {
        if (typeof localStorage === 'undefined') return def
        const ov = JSON.parse(localStorage.getItem('feSettings') || '{}')
        if (key in ov) return ov[key]
        let v = JSON.parse(localStorage.getItem('feSettings.db') || '{}')
        for (const part of key.replace(/^fe\./, '').split('.')) { if (!v || typeof v !== 'object') { v = undefined; break } v = v[part] }
        if (v !== undefined && v !== null && v !== '') return v
    } catch (e) { /* приватный режим / чужой формат — дефолт */ }
    return def
}
// зовётся на каждую строку интерфейса и ячейку: настройка перечитывается не чаще раза в 2 с
export function modelV2_on() {
    if (_forced !== null) return _forced
    const now = Date.now()
    if (now - _at > 2000) { const v = feFlag_read(MODEL_V2_KEY, true); _cached = v !== false && v !== 'false'; _at = now }
    return _cached
}

// сегменты ссылочных полей модели
export const SIGNAL_SEGMENTS = { kind: 'SIGNAL-KIND', grade: 'GRADE', signal: 'METRIC', cause: 'REASON', solution: 'SOLUTION', basis: 'AMOUNT-BASIS' }
export const SIGNAL_KIND_PREFIX = 'SIGNAL-KIND_'
// id записи вида → код вида (problem | kpi | info); код остаётся кодом
export function sigKind_code(id) { const s = String(id || ''); return s.startsWith(SIGNAL_KIND_PREFIX) ? s.slice(SIGNAL_KIND_PREFIX.length) : s }
export function sigKind_id(code) { const s = String(code || ''); return !s || s.startsWith(SIGNAL_KIND_PREFIX) ? s : SIGNAL_KIND_PREFIX + s }

// строка грида сигналов новой модели: вид — id записи SIGNAL-KIND
export function sigRow_isV2(row) { return !!row && typeof row === 'object' && typeof row.signal_kind === 'string' && row.signal_kind.startsWith(SIGNAL_KIND_PREFIX) }
// ссылочные колонки строки грида, у которых бэк отдаёт запасное название `<binding>_title`
const ROW_TITLE_BINDINGS = { metric: 'metric_title', reason: 'reason_title' }
// название ссылки строки грида сигналов v2 ОТ БЭКА (название записи под язык запроса; до пересева сегмента — название каталога кода): '' — строка прежней
// модели, колонка не ссылочная, значение пусто либо выключатель снят. ids — словарь колонки ({id: {title}}): запись в нём есть — '' (название даёт словарь)
export function sigRow_refTitle(row, binding, ids = null) {
    const f = ROW_TITLE_BINDINGS[binding]
    if (!f || !sigRow_isV2(row) || !modelV2_on()) return ''
    const id = row[binding]
    if (id === undefined || id === null || id === '') return ''
    if (ids && ids[id] && ids[id].title) return ''
    const v = row[f]
    return typeof v === 'string' && v && v !== String(id) ? v : ''
}

// IE 2026 10 05 / ODOO-5800 (fe-85) (Igor 05.10, п. 3 «да»: «подсказка с числами … при наведении на причину в гриде сигналов»): ЧИСЛА ПРОВЕРКИ ПРИЧИНЫ. Бэк (BE cause detail,
// выключатель not-signals.cause_detail) кладёт строке грида сигналов готовую строку под язык запроса reason_detail («Документ 12.10.2026 · партію можна продавати до
// 30.09.2026 · норма: залишок ≥ 60 % терміну»), причине формы ячейки — ключ detail. Фронт текст не собирает и не переводит: показывает как есть — подсказкой
// (title) ячейки «Причина» грида и мелкой строкой под строкой проблемы / в карточке причины формы. Поля нет (прежний бэк, причина без чисел) — как было.
// Выключатель fe.signals.causeDetail (дефолт ВКЛ; false — подсказки и строки нет и при новом бэке).
export const CAUSE_DETAIL_KEY = 'fe.signals.causeDetail'
export const CAUSE_DETAIL_ROW_FIELD = 'reason_detail'
export const CAUSE_DETAIL_BINDING = 'reason'
// on — значение настройки либо функция, которая её читает (грид зовёт на каждую ячейку: настройка читается только у строки с числами)
const _cdOn = (on) => { const v = typeof on === 'function' ? on() : on; return v !== false && v !== 'false' }
// строка подсказки ячейки грида сигналов: только колонка «Причина» и непустая строка бэка; on — значение настройки fe.signals.causeDetail
export function sigRow_causeDetail(row, binding, on = true) {
    if (binding !== CAUSE_DETAIL_BINDING || !row || typeof row !== 'object') return ''
    const v = row[CAUSE_DETAIL_ROW_FIELD]
    const tx = typeof v === 'string' ? v.trim() : ''
    return tx && _cdOn(on) ? tx : ''
}
// строка чисел причины формы ячейки (story.causes[].detail / problems[].causes[].detail)
export function cause_detailText(cause, on = true) {
    if (!cause || typeof cause !== 'object') return ''
    const tx = typeof cause.detail === 'string' ? cause.detail.trim() : ''
    return tx && _cdOn(on) ? tx : ''
}
// подсказка ячейки грида ставится и снимается своим признаком: чужую подсказку не затирает, свою при переиспользовании ячейки убирает
export function sigCell_setCauseDetail(cell, text) {
    if (!cell) return false
    if (text) { cell.title = text; cell.__cdTitle = true; return true }
    if (cell.__cdTitle) { cell.title = ''; cell.__cdTitle = false }
    return false
}
// IE 2026 10 06 / ODOO-5800 (fe-88) (второе ревью cause detail): ЧТО поставить ячейке «Причина» — чистое решение, грид только исполняет (AttrGrid.causeDetail_cellApply).
// Вход: text — строка чисел строки грида ('' — её нет), showTooltip — режим Show tooltips, cachePath — кэш-путь formatItem, hadCard — элемент ячейки несёт карточку
// wijmo со строкой чисел (отметка __cdCard). Выход: title — нативная подсказка ('' — снять свою); card — 'set' перерегистрировать карточку (Show tooltips, кэш-путь:
// полный путь карточку ставит сам formatItem_cells), 'clear' снять карточку, оставшуюся от режима Show tooltips (режим выключили: иначе по Alt две подсказки, а после
// прокрутки — числа чужой строки), 'keep' не трогать; hasCard — новая отметка __cdCard
export function sigCell_causeDetailPlan(text, showTooltip, cachePath, hadCard) {
    const tx = typeof text === 'string' ? text : ''
    const full = !!showTooltip
    return {
        title: full ? '' : tx,
        card: full ? ((cachePath && (tx || hadCard)) ? 'set' : 'keep') : (hadCard ? 'clear' : 'keep'),
        hasCard: full && !!tx,
    }
}
// IE 2026 10 05 / ODOO-5800 (fe-85) (ревью cause detail: две подсказки сразу — карточка wijmo и нативный title): пока над ячейкой показана карточка по Alt (строка чисел
// стоит в её шапке — AttrGrid.cellTooltip_html), нативная подсказка ячейки снимается и возвращается, когда курсор уходит с ячейки. Ячейку за это время мог
// переиспользовать грид: возвращается только своя подсказка (отметка __cdTitle) и только если новой нет. → true — подсказка снята
export function sigCell_holdCauseDetail(cell) {
    if (!cell || !cell.__cdTitle || !cell.title) return false
    const text = cell.title
    cell.title = ''
    const back = () => { if (cell.__cdTitle && !cell.title) cell.title = text }
    if (typeof cell.addEventListener === 'function') cell.addEventListener('mouseleave', back, { once: true })
    else back()
    return true
}

// словарь чипса новой модели: записи несут signal_kind_id
export function sigRules_isV2(rules) { return Array.isArray(rules) && rules.some(e => e && e.signal_kind_id !== undefined) }
// названия записей по id из словаря виджета / стола (attr.metric_rules, metric_chip_keys): {METRIC, REASON, GRADE, 'SIGNAL-KIND', SOLUTION} → Map(id → название).
// Словарь — единственный источник названий записей на фронте без запроса; SOLUTION словарь названий не несёт (только id) — карта остаётся пустой
export function sigNames_fromRules(rules, into = null) {
    const N = into || { METRIC: new Map(), REASON: new Map(), GRADE: new Map(), 'SIGNAL-KIND': new Map(), SOLUTION: new Map(), 'AMOUNT-BASIS': new Map() }
    for (const e of Array.isArray(rules) ? rules : []) {
        if (!e || typeof e !== 'object') continue
        if (e.metric && e.metric_title) N.METRIC.set(String(e.metric), String(e.metric_title))
        if (e.reason && e.reason_title) N.REASON.set(String(e.reason), String(e.reason_title))
        if (e.grade && e.grade_title) N.GRADE.set(String(e.grade), String(e.grade_title))
        if (e.signal_kind_id && e.signal_kind_title) N['SIGNAL-KIND'].set(String(e.signal_kind_id), String(e.signal_kind_title))
    }
    return N
}
// ссылка на запись справочника: {id, segment, title} — title: название записи (names), иначе запасной текст, иначе id; пустой id — null
export function sigRef(segment, id, names = null, fallback = '') {
    const s = id === undefined || id === null ? '' : String(id)
    if (!s || !segment) return null
    const m = names && names[segment]
    const title = (m && typeof m.get === 'function' && m.get(s)) || (fallback ? String(fallback) : '') || s
    return { id: s, segment, title, known: !!(m && typeof m.get === 'function' && m.get(s)) }
}

// IE 2026 10 05 / ODOO-5800 (fe-81) (ревизия потребителей сигналов v2, AUDIT.md № 37): СИГНАЛЫ-ДВИЖЕНИЯ — строка уровня movement с таким сигналом есть выполненное
// движение (документ прошёл по правилу), а не замечание о непокрытом. Как бэк signal_model.signal_of: прежняя метрика has_movement остаётся собой (info) либо
// становится push (причина push::*), stock_expired_exit (expired::*), confirmed_in_past (*::bad_in_past), receipt_at_risk (in::*) / shipment_at_risk (out::*) —
// три последних при плохой оценке. uncovered_demand в набор не входит (непокрытая часть); строка uncovered_demand, чья прежняя метрика — has_movement
// (rule_metric), считается движением, как и до v2 (та же строка has_movement с причиной uncovered::*) — поведение обоих составов одинаково.
export const SIGNAL_MOVEMENTS = new Set(['has_movement', 'push', 'receipt_at_risk', 'shipment_at_risk', 'confirmed_in_past', 'stock_expired_exit'])
// прежние id метрик движений (состав до v2; в v2 — служебная колонка rule_metric строки, когда сигнал отличается от прежней метрики)
const RULE_MOVEMENTS = new Set(['has_movement', 'push'])
// строка — движение: по id сигнала (metric) либо по прежнему id (rule_metric; не строка / пусто — колонки нет или значение не менялось). От выключателя не зависит:
// чтение обоих составов id
export function sigRow_isMovement(metric, ruleMetric = '') {
    const m = typeof metric === 'string' ? metric : '', rm = typeof ruleMetric === 'string' ? ruleMetric : ''
    return SIGNAL_MOVEMENTS.has(m) || RULE_MOVEMENTS.has(rm)
}
